import 'react-toastify/dist/ReactToastify.css'

import React from 'react'
import { Slide, toast } from 'react-toastify'

import {
   AlertCircleIcon,
   AlertTriangleIcon,
   CheckCircleIcon
} from '@flowwai-frontend/design-system/icons'
import { colors } from '@flowwai-frontend/shared/style-guide'

import { ToastComponent } from '../components/ToastComponent/ToastComponent'
import { ToastType } from '../types/ToastTypes'

let toastId: string | number

function dismissToast(id = toastId): void {
   if (toast.isActive(id)) {
      toast.dismiss(id)
   }
}

const renderFailureLeftIcon = (color: string): React.ReactElement => (
   <AlertCircleIcon height={20} width={20} fill={color} />
)

export const showToastWithTitleAndDescription = (
   title: string,
   toastType: ToastType,
   renderLeftIcon: (color: string) => React.ReactElement,
   autoClose?: number,
   description?: string
) => {
   dismissToast()
   toastId = toast(
      <ToastComponent
         title={title}
         description={description}
         toastType={toastType}
         renderLeftIcon={(color: string) => renderLeftIcon(color)}
         dismissToast={() => dismissToast()}
      />,
      {
         position: 'bottom-center',
         autoClose: autoClose,
         bodyClassName: 'font-inter',
         transition: Slide
      }
   )
}

export const showFailureToast = (message: string) => {
   showToastWithTitleAndDescription(message, 'FAILURE', renderFailureLeftIcon)
}

const renderSuccessLeftIcon = (): React.ReactElement => (
   <CheckCircleIcon height={20} width={20} />
)

const renderPrimaryLeftIcon = (): React.ReactElement => (
   <CheckCircleIcon height={20} width={20} fill={colors['primary-600']} />
)

export const showCRMSuccessToast = (message: string, autoClose = 3000) => {
   showToastWithTitleAndDescription(
      message,
      'SUCCESS',
      renderSuccessLeftIcon,
      autoClose
   )
}

export const showPrimaryToast = (message: string, autoClose = 3000) => {
   showToastWithTitleAndDescription(
      message,
      'PRIMARY',
      renderPrimaryLeftIcon,
      autoClose
   )
}

const renderWarningLeftIcon = (): React.ReactElement => (
   <AlertTriangleIcon height={20} width={20} />
)

export const showCRMWarningToastWithGivenMessage = (message: string) => {
   showToastWithTitleAndDescription(message, 'WARNING', renderWarningLeftIcon)
}
